import React from "react";

export default function ComponentLoading({ parrentClassName }) {
  return (
    <div className={`component-loader-container ${parrentClassName}`}>
      <div className="component-loader" />
    </div>
  );
}
